import { TallyRecord } from "./TallyRecord";

export interface TallyDraft {
  serverUrl: string;
  dbKey: string;
  transRefCode: string;
  detailNo: number;
  stockCode?: string;
  stockNo?: string;
  tallies: TallyRecord[];
  //false until esuite has accepted the tallies - unposted tallies are kept so a
  //part-counted line survives leaving the screen, or the app being closed
  posted: boolean;
  //the operator answered Ignore to "this stockcode has no stock barcode" - don't ask again
  //while this line is being tallied. It goes with the draft rather than the screen so
  //stepping out to the line list and back does not start asking again; posting or clearing
  //the line drops the draft, and the next tally session asks once more.
  ignoreMissingStockBarcode?: boolean;
  savedAt: string;
}

export const sumTallyEffectQty = (draft?: TallyDraft): number => {
  if (!draft || !draft.tallies) {
    return 0;
  }
  return draft.tallies.reduce((total, t) => total + (t.tallyEffectQty || 0), 0);
};

//Serial.UseByDate is set to the earliest use-by across the tallies
export const minTallyUseByDate = (draft?: TallyDraft): string | undefined => {
  if (!draft || !draft.tallies) {
    return undefined;
  }
  const dates = draft.tallies.map((t) => t.useByDate).filter((d): d is string => !!d);
  if (dates.length === 0) {
    return undefined;
  }
  return dates.reduce((min, d) => (d < min ? d : min));
};
